import { v4 as uuidv4 } from 'uuid';

export function NewsletterInputName(props = {}, childrenComponents = []) {
	return {
		componentName: 'NewsletterInputName',
		componentId: uuidv4(),
		props: Object.assign(
			{
				blockClass: 'newsletter__input-name',
				placeholderText: 'Digite seu nome...',
				inputLabel: '',
			},
			props,
		),
		childrenComponents,
	};
}
